import { render } from "./LandingSection.vue?vue&type=template&id=695a98c0&scoped=true&ts=true&lang=pug"
import script from "./LandingSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingSection.vue?vue&type=script&lang=ts&setup=true"

import "./LandingSection.vue?vue&type=style&index=0&id=695a98c0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695a98c0"]])

export default __exports__